import { Empty } from "antd";
import React, { useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useAxisLabelFontStyle } from "../../../Utlis/CharStyle";
import GraphLayout from "../../GraphLayout";

const LineChart = ({
  graphData,
  lengthKeys,
  colourTheme = ["#000", "#fff"],
  graphTitle = "Undefined",
  selectTenByDefault = false,
  classNameCSS,
  units = [],
}) => {
  const { axisLabelFontStyle, chartRef } = useAxisLabelFontStyle();
  const [filteredLabels, setFilteredLabels] = useState([]);
  const [series, setSeries] = useState([]);

  const filteredGraphData = useMemo(() => {
    if (!graphData || !lengthKeys) return graphData;

    const entries = Object.entries(graphData);
    const slicedEntries = entries.slice(0, lengthKeys + 1);
    return Object.fromEntries(slicedEntries);
  }, [graphData, lengthKeys]);

  if (graphData?.labels?.length < 1 || graphData?.label?.length < 1) {
    return (
      <GraphLayout
        title={graphTitle}
        data={filteredGraphData}
        setFilteredLabels={setFilteredLabels}
        series={series}
        setSeries={setSeries}
        selectTenByDefault={selectTenByDefault}
        colourTheme={colourTheme}
        classNameCSS={classNameCSS}
      >
        <Empty
          style={{
            height: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          description={
            <span style={{ color: "#FB3748" }}>
              {`No ${graphTitle} data available`}
            </span>
          }
        />
      </GraphLayout>
    );
  }

  const options = {
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: "none",
    },
    colors: colourTheme,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    markers: {
      size: 3,
      colors: colourTheme,
      strokeColors: colourTheme,
      strokeWidth: 2,
      hover: {
        size: 5,
      },
    },
    xaxis: {
      categories: filteredLabels,
      labels: {
        style: axisLabelFontStyle,
        offsetX: 10,
      },
      axisBorder: {
        show: true,
        color: "var(--stroke, #E4E4E7)",
      },
      axisTicks: {
        show: true,
        color: "var(--stroke, #E4E4E7)",
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value ? value.toFixed(2) : "0.00";
        },
        style: axisLabelFontStyle,
      },
      axisBorder: {
        show: true,
        color: "var(--stroke, #E4E4E7)",
      },
      axisTicks: {
        show: true,
        color: "var(--stroke, #E4E4E7)",
      },
    },

    legend: {
      show: false,
    },
    grid: {
      borderColor: "var(--stroke, #E4E4E7)",
      strokeDashArray: 0,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    tooltip: {
      enabled: true,
      y: units.map((unit) => ({
        formatter: function (val) {
          if (val === undefined || val === null) return "";

          if (unit === "$") {
            return `${unit} ${val}`;
          }

          return `${val} ${unit}`;
        },
      })),
    },
  };

  return (
    <GraphLayout
      title={graphTitle}
      data={filteredGraphData}
      setFilteredLabels={setFilteredLabels}
      series={series}
      setSeries={setSeries}
      selectTenByDefault={selectTenByDefault}
      colourTheme={colourTheme}
      classNameCSS={classNameCSS}
    >
      <div ref={chartRef}>
        <ReactApexChart
          height={300}
          options={options}
          series={series}
          type="line"
        />
      </div>
    </GraphLayout>
  );
};

export default LineChart;
